// libs
import React from 'react';
import { useTranslation } from "react-i18next";

// components
import CardGeneric from "../Cards/CardGeneric";
import {read} from "sheetjs-style";
import TankLevelGraph from "./TankLevelGraph";

const TankDetails = (props) => {
	const { tank, readingDevice } = props;
	const { t, i18n } = useTranslation();

	const renderTimeFromHours = (numberOfHours) => {
		const days= Math.floor(numberOfHours/24);
		const remainder= numberOfHours % 24;
		const hours= Math.floor(remainder);
		const minutes= Math.floor(60*(remainder - hours));

		let timeFormat = "";
		if(days > 0){
			timeFormat += days + ' ';
			if(days === 1) timeFormat += t('misc.time_format.day');
			else timeFormat += t('misc.time_format.days');
			if(hours > 0 || minutes > 0){
				timeFormat += ' ' + t('misc.and') + ' ';
			}
		}
		if(hours > 0){
			timeFormat += hours + ' ';
			if(hours === 1) timeFormat += t('misc.time_format.hour');
			else timeFormat += t('misc.time_format.hours');
			if(minutes > 0){
				timeFormat += ' ' + t('misc.and') + ' ';
			}
		} else if(minutes > 0) {
			timeFormat += minutes + ' ' + t('misc.time_format.minutes');
			timeFormat += ' ';
		}

		return timeFormat;
	}

	let introTitle = null;
	if(readingDevice){
		introTitle = (
			<div className="flex flex-row flex-wrap justify-content-between align-items-center" style={{width:"100%"}}>
				<h2 className="headline headline--section mt-1 mb-1">{ t('tanks.details.intro.title') }</h2>
				{ (readingDevice.lastStatus) ? (
					<h3 className="headline headline--block mt-1 mb-1">
						{ t('tanks.details.intro.status.label') }&nbsp;<span style={{ color: (readingDevice.lastStatus.code === "O") ? '#55B545' : '#EE1B21' }}>
					{
						(i18n.language === "fr")
							? readingDevice.lastStatus.descriptionFr
							: readingDevice.lastStatus.descriptionEn
					}
					</span>
					</h3>
				) : '' }
			</div>
		)
	}

	return (
		(readingDevice && tank) ? (
				<CardGeneric customTitle={introTitle} additionalClasses={['card--discreet', 'card--intro', 'mt-5']}>
					<div className="row">
						<div className="col-md-6 col-lg-4">
							<p className="card__intro__subtitle">
								{ (readingDevice.address) && ( <><span>{ readingDevice.address }</span><br/></> ) }
								{ (readingDevice.city) && ( <><span>{ readingDevice.city }</span><br/></> ) }
								{ (readingDevice.region || readingDevice.country || readingDevice.postalCode) && (
									<>
										{ (readingDevice.postalCode) ? (
											<>
												<span>{ readingDevice.postalCode }</span>
												{ (readingDevice.region || readingDevice.country) ? ', ' : '' }
											</>
										) : ''
										}
										{ (readingDevice.region) ? (
											<>
												<span>{ readingDevice.region }</span>
												{ (readingDevice.country) ? ', ' : '' }
											</>
										) : '' }
										{ (readingDevice.country) ? ( <><span>{ readingDevice.country }</span></> ) : '' }
									</>
								) }
							</p>
							{ (readingDevice.latitude || readingDevice.longitude) ? (
								<>
									<hr/>
									<p className="p tank__coordinates">
										{ t("tanks.details.intro.coordinates") }<br/>
										<strong>
											{ (readingDevice.latitude) ? (<span>{readingDevice.latitude}&nbsp;</span>) : '' }
											{ (readingDevice.longitude) ? (<span>{readingDevice.longitude}</span>) : '' }
										</strong>
									</p>
								</>
							) : '' }
						</div>
						<div className="col-md-6 col-lg-4">
							{ (readingDevice.lastHoursToEmpty !== null) ? (
								<>
									<p className="p">
										{ t('tanks.details.level.time_to_empty') }<br/>
										<strong>{ renderTimeFromHours(readingDevice.lastHoursToEmpty) }</strong>
									</p>
								</>
							) : ''}
							{
								(readingDevice.note) ? (
									<>
										<hr />
										<p className="p">
											{ t('tanks.details.intro.notes') }<br/>
											<strong><em>{readingDevice.note}</em></strong>
										</p>
									</>
								) : ''
							}
						</div>
						<div className="col-12 col-md-12 col-lg-4">
							<div className="tank__level-wrapper">
								<div className="row">
									<div className="col-12 col-md-6 tank__capacity">
										{
											(tank.product) ? (
												<p className="tank__attribute">
													<span className="tank__attribute__label">{t("account.tabs.tanks.product")}</span>
													<strong className="tank__attribute__value">
														{
															i18n.language === "fr"
																? tank.product.descriptionFr
																: tank.product.descriptionEn
														}
													</strong>
												</p>
											) : ''
										}
										{
											(tank.capacity && tank.capacity.formattedUnitValue)
												? (
													<p className="tank__attribute">
														<span className="tank__attribute__label">{t("account.tabs.tanks.capacity")}</span>
														<strong className="tank__attribute__value tank__attribute__value--2x">
															{ tank.capacity.formattedUnitValue }
														</strong>
													</p>
												)
												: ''
										}
										{
											(readingDevice.lastUllage)
												? (
													<p className="tank__attribute">
														<span className="tank__attribute__label">{t("tanks.details.level.ullage")}</span>
														<strong className="tank__attribute__value tank__attribute__value--2x">
															{ readingDevice.lastUllage + ' ' + tank.capacity.unit }
														</strong>
													</p>
												)
												: ''
										}
									</div>
									<div className="col-12 col-md-6 tank__level-box">
										<TankLevelGraph level={ (readingDevice.lastLevel) ? readingDevice.lastLevel : null }/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</CardGeneric>
		) : ''
	);
};

export default TankDetails;
